// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import Icon from 'app/common/components/Icon';
import KindPropType from 'app/common/KindPropType';
import 'app/common/components/MessageBar.scss';

const bem = bemify('message-bar');

const kindToBarConfig = {
  error: { icon: 'error', defaultMessage: 'Bargle!' },
  success: { icon: 'check', defaultMessage: 'Success!' },
  'success-phantom': { icon: 'check', defaultMessage: 'Success!' },
  'success-ghost': { icon: 'check', iconSize: 20, defaultMessage: 'Success!' },
  warning: { icon: 'alert', defaultMessage: 'Warning!' },
  info: { icon: 'info', defaultMessage: 'Info!' },
  alert: { icon: 'alert', defaultMessage: 'Alert!' },
  team: { icon: 'team', defaultMessage: 'Team!' },
};

const MessageBar = props => {
  const { iconSize, defaultMessage } = kindToBarConfig[props.mainKind];
  const iconType =
    props.icon !== undefined
      ? props.icon
      : kindToBarConfig[props.mainKind].icon;
  const className = bem(
    toModifiers(props.mainKind, props.kind),
    props.className
  );
  const icon = !iconType ? null : (
    <Icon className={bem('__icon')} size={iconSize} type={iconType} />
  );
  const dismissButton = !props.onDismiss ? null : (
    <Icon
      className={bem('__dismiss')}
      onClick={props.onDismiss}
      type="delete"
    />
  );
  return (
    <div className={className}>
      {icon}
      <div className={bem('__message')}>{props.children || defaultMessage}</div>
      {dismissButton}
    </div>
  );
};

MessageBar.propTypes = {
  mainKind: PropTypes.oneOf(Object.keys(kindToBarConfig)).isRequired,
  onDismiss: PropTypes.func,
  icon: PropTypes.string,
  className: PropTypes.string,
  kind: KindPropType,
};

export default MessageBar;

const withMainKind = mainKind => props => (
  <MessageBar {...props} mainKind={mainKind} />
);

export const MessageBarText = ({ children, className, kind }) => (
  <p className={bem('__text', toModifiers(kind), className)}>{children}</p>
);

export const MessageBarList = ({ children, className, kind, tag }) =>
  React.createElement(
    tag,
    {
      className: bem('__list', toModifiers(kind), className),
    },
    children
  );

MessageBarList.propTypes = {
  tag: PropTypes.oneOf(['ol', 'ul']),
};

MessageBarList.defaultProps = {
  tag: 'ul',
};

export const ErrorBar = withMainKind('error');
export const WarningBar = withMainKind('warning');
